module.exports = __webpack_public_path__ + "img/icon05.f3f9de94.png";